import React from "react"
import { FleLayout } from "../FleLayout"
import { BackArrow, ContinueArrow, SwitchH2ToBodyLarge } from "../Molecules"
import { HelperText, Label, Spacer } from "../../atoms/Atoms"
import { MultiPathSVG } from "../../SVG"
import { FleLinkWrapper } from "../../atoms/Links"
import L10n from "../../../../lib/carrot-l10n"
import { FormInput } from "components/views/atoms/forms/FormInput"
import { TopSection } from "../TopSection"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

export const PersonalEmail = ({ personalEmail, setPersonalEmail, validEmail, onComplete }) => {
  const completeOnEnter = (e) => {
    if (e.key === "Enter") {
      onComplete()
    }
  }

  return (
    <FleLayout>
      <TopSection progressStep={2} leftOrBackArrow={<BackArrow />} />
      <SwitchH2ToBodyLarge>{l`Which email should we use to contact you?`}</SwitchH2ToBodyLarge>
      <Spacer height={2} />
      <Label htmlFor="personalEmail" valid={validEmail}>
        {l`Contact email address`}
      </Label>
      <Spacer height={0.5} />
      <FormInput
        name={"personalEmail"}
        onChange={(e) => setPersonalEmail(e.target.value)}
        value={personalEmail}
        valid={validEmail}
        onKeyDown={completeOnEnter}
      />
      {!validEmail && (
        <div className="mt2">
          <MultiPathSVG iconName="X" className="dib v-mid" />
          <div className="dib ml2">
            <HelperText color="invalid-red">{l`client.invalidEmail`}</HelperText>
          </div>
        </div>
      )}
      <FleLinkWrapper>
        <ContinueArrow onClick={onComplete} />
      </FleLinkWrapper>
    </FleLayout>
  )
}
